import { call, put, select } from 'redux-saga/effects';

import { getClientsIds, getReCaptchaToken, reportJSError } from '@/utils/util';
import { recaptchaActions as recaptchaConstants } from '@/constants/constant';
import sendRetargeting from '@gcloud-npm/adabyron.misc.send-retargeting';
import { actions as retargetingActions } from '@/reducers/retargeting';

const context = (state) => state.main.context;

export function* sendRetargetingSaga({ payload }) {
  const contextApi = yield select(context);
  try {
    const { contextURL } = { ...contextApi };
        const dataPayload = {
          campaign: {
            id: 'ret-solar-lead',
            externalId : ''
          },
          products: [
          ],
          context: {
            url: btoa(contextURL),
            ga: getClientsIds(contextApi),
          },
          contactInfo: {
            ...payload.data,
          },
        };
        const recaptchaToken = yield call(getReCaptchaToken, {
          action: recaptchaConstants.RETARGETING,
        });
        yield call(sendRetargeting, {
          data: {...dataPayload, recaptchaToken},
          context: contextApi
        });
        yield put(retargetingActions.sendRetargetingSuccess());
  } catch (error) {
    reportJSError(error, 'retargeting', 'sagas/retargeting-sagas', contextApi);
    yield put(retargetingActions.sendRetargetingFailure());
  }
}
